/**
 * @Author: 仙道
 * @Date: 2022-04-27 22:06:48
 * @LastEditTime: 2022-08-14 13:50:04
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/utils/dict.js
 **/
const equipment = {
  // 未投运、已投运、报废
  equipmentStatus: [
    {
      value: 1,
      name: '未投运'
    },
    {
      value: 2,
      name: '已投运'
    },
    {
      value: 3,
      name: '报废'
    }
  ]
}
const detailPathByKey = {
  'manufacturers': '/fusion/manufacturers',
  'person': '/fusion/person'

}
export { equipment, detailPathByKey }
